module.exports = __webpack_public_path__ + "img/Icon-order-arrow-down.92bcd0bf.svg";